import { actionsNamespace } from "../actions-namespace"

export const appNamespace = `${actionsNamespace}app/`